<ng-template #offerCard let-offer>
  <lumiron-card [id]="offer.anchor">
    <lumiron-card-header>
      <lumiron-card-title>{{ offer.title }}</lumiron-card-title>
      <lumiron-card-summary>{{ offer.summary }}</lumiron-card-summary>
    </lumiron-card-header>

    <lumiron-card-body>
      <div class="information">
        <div class="prices">
          @for (price of offer.prices; track price.label) {
          <span class="price">{{ formatChf(price.amount) }}</span>
          <span class="duration">{{ price.label }}</span>
          }
        </div>

        <lumiron-list>
          <lumiron-list-title>Im Angebot inklusive sind:</lumiron-list-title>
          @for (item of offer.included; track item) {
          <lumiron-list-item>{{ item }}</lumiron-list-item>
          }
        </lumiron-list>

        <lumiron-list>
          <lumiron-list-title>Weiteres:</lumiron-list-title>
          @for (extra of offer.extras; track extra.description) {
          <lumiron-list-item>
            @if (extra.amount !== undefined) { {{ extra.description }}:
            <span>{{ formatChf(extra.amount) }}@if (extra.unit === 'bubble') {/Bubble}</span>
            @if (extra.unit === 'bubble') { (max {{ offer.maxBubbles }} Bubbles) } } @else { {{ extra.description }} }
          </lumiron-list-item>
          }
        </lumiron-list>
      </div>
    </lumiron-card-body>

    <lumiron-card-footer>
      <lumiron-button-link [link]="'/buchung'">Online buchen</lumiron-button-link>
    </lumiron-card-footer>
  </lumiron-card>
</ng-template>

<lumiron-section>
  <lumiron-section-header>
    <lumiron-section-title>Bubble Soccer</lumiron-section-title>
    <lumiron-section-summary
      >Für Erwachsene/Teenager bieten wir sowohl betreutes, wie auch unbetreutes Bubble Soccer
      an.</lumiron-section-summary
    >
  </lumiron-section-header>

  <lumiron-section-body>
    @for (offer of adultOffers; track offer.id) {
    <ng-container *ngTemplateOutlet="offerCard; context: { $implicit: offer }" />
    }
  </lumiron-section-body>
</lumiron-section>

<lumiron-section>
  <lumiron-section-header>
    <lumiron-section-title>Bubble Soccer Kids</lumiron-section-title>
    <lumiron-section-summary>Für Kinder bieten wir unbetreutes Bubble Soccer an.</lumiron-section-summary>
  </lumiron-section-header>

  <lumiron-section-body>
    @for (offer of kidsOffers; track offer.id) {
    <ng-container *ngTemplateOutlet="offerCard; context: { $implicit: offer }" />
    }
  </lumiron-section-body>
</lumiron-section>
